import { inject, Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { HotToastService } from "@ngxpert/hot-toast";
import { catchError, EMPTY, map, noop, Observable } from "rxjs";
import { ApiService } from "../../../../api/packbo/api.service";
import { createItemsContactFormSubmissions } from "../../../../api/packbo/fn/items/create-items-contact-form-submissions";
import { ItemsContactFormSubmissions } from "../../../../api/packbo/models/items-contact-form-submissions";
import { setLoadingState } from "../../../../rxjs/set-loading-state.operator";
import { showSuccessOrErrorToast } from "../../../../rxjs/show-success-or-error-toast.operator";
import { ContactFormBlockStore } from "./contact-form-block.store";

@Injectable()
export class ContactFormBlockService {
    private readonly store = inject(ContactFormBlockStore);
    private readonly hotToast = inject(HotToastService);
    private readonly translocoService = inject(TranslocoService);
    private readonly apiService = inject(ApiService);

    public createContactFormSubmission(form: ItemsContactFormSubmissions): Observable<void> {
        return this.apiService.invoke(createItemsContactFormSubmissions, { body: form }).pipe(
            setLoadingState(this.store, "submitting"),
            showSuccessOrErrorToast(this.hotToast, {
                message: {
                    success: this.translocoService.translate("contact_form_block.toasts.success"),
                    error: this.translocoService.translate("contact_form_block.toasts.error")
                }
            }),
            map(noop),
            catchError(() => EMPTY)
        );
    }
}
